"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IEventSender.js.map